export default "__VITE_ASSET__dadF0Eqn__"